"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'file.upload.choose': '选择文件...',
    'file.upload.change': '更改文件',
    'file.upload.remove': '移除文件',
    'file.upload.loading': '加载中...',
    'file.upload.drop': '拖拽文件到这里',
    'file.upload.download': '下载文件',
    'file.upload.choose_multiple': '选择文件...',
    'file.upload.change_multiple': '更改文件',
    'file.upload.remove_all': '删除所有文件',
    'file.upload.error.size_too_large': '文件"{fileName}"太大。最大文件大小为2MB。',
    'file.upload.error.size_exceeded_10mb': '文件"{fileName}"太大。最大文件大小为{maxSize}。',
    'file.upload.error.multiple_files_size_exceeded_10mb': '以下文件太大：{fileNames}。最大文件大小为{maxSize}。',
    'file.upload.error.image_too_large': '图片"{filename}" ({size})太大。图片必须小于{maxSize}。',
    'file.upload.error.unsupported_type': '不支持的文件类型。请选择支持的文件格式。',
    'file.upload.confirm.add_to_knowledge': '文件"{fileName}" ({fileSize})对于聊天来说太大了。您想将其添加到知识库中吗？',
    'file.upload.error.total_size_exceeded': '添加此文件将超过5MB总限制。当前总计：{currentSize}，尝试添加：{newSize}。',
    'file.upload.error.processing_failed': '处理文件"{fileName}"时出错：{error}',
    'file.upload.error.upload_failed': '上传文件时出错：{error}',
    'file.upload.error.submission_failed': '聊天提交时出错：{error}',
};
